import React, { Fragment, useContext } from "react";
import {
  PageHeading,
  TableOfContents,
  Mui,
  TOC,
  MuiStyles
} from "@osu/react-ui";
import Routes from "../../Routes/components";

const createClasses = (theme) => {
  return {
    root: {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row-reverse'
      },
      minHeight: "calc(100vh - var(--nav-height) - var(--footer-height))"
    },
    toc: {
      zIndex: theme.zIndex.appBar - 2
    },
  };
};

function Main(props = defaultProps) {
  const { unauthorized, loading, spacingTop, ...rest } = props;
  const theme = MuiStyles.useTheme()
  const mdUp = Mui.useMediaQuery(theme => theme.breakpoints.up('md'));
  const classes = createClasses(theme);
  const { exists } = useContext(TOC.Context);

  return (
      <Mui.Box flexGrow={100} sx={classes.root} {...rest}>
        {mdUp && <TableOfContents
            spacingTop={spacingTop}
            PaperProps={{
              sx: classes.toc,
            }}
            StylizedLinkProps={{ color: "primary" }}
          />}
        <Mui.Container className="margin-y-4" maxWidth="lg">
          {
            mdUp 
              ? <PageHeading />
              : <Fragment>
                <header className="display-flex">
                  <PageHeading />
                </header>
                {exists && <TableOfContents variant="popover" />}
              </Fragment>
          }
          <Routes />
        </Mui.Container>
      </Mui.Box>
  );
}

const defaultProps = {
  className: "",
  tabIndex: "-1",
  component: "main",
};

export default Main